import type { Term } from '../systems/EventBus';

export interface TeachPanelCopy {
  term: Term;
  title: string;
  definition: string;
  empathyLine: string;
}

export const TEACH_PANELS: Record<Term, TeachPanelCopy> = {
  'aging-bucket': {
    term: 'aging-bucket',
    title: 'aging bucket',
    definition:
      'Invoices grouped by how many days past due they are — 0–30, 31–60, 61–90, 90+. The 90+ bucket is where money goes to die.',
    empathyLine:
      'In the real world, clerks stare at this report every morning. The 90+ column never really shrinks.',
  },
  dunning: {
    term: 'dunning',
    title: 'dunning',
    definition:
      'Sending escalating reminders to get customers to pay. Polite nudge → firm → final → collections.',
    empathyLine: 'Picking the wrong template torches the relationship or wastes the escalation.',
  },
  'cash-application': {
    term: 'cash-application',
    title: 'cash application',
    definition:
      'Matching an incoming wire or check to the right customer and the right invoices.',
    empathyLine:
      'Apply to the wrong customer and you just created two problems: an angry payer and a still-open invoice.',
  },
  'short-pay': {
    term: 'short-pay',
    title: 'short-pay',
    definition:
      'A customer pays less than the invoice amount. Could be a mistake, a dispute, or a credit memo in flight.',
    empathyLine: 'Applying a short-pay blindly hides the real dispute. Catching it is the craft.',
  },
  dispute: {
    term: 'dispute',
    title: 'dispute',
    definition:
      'A customer pushes back on an invoice — wrong amount, wrong PO, billing error, or "we already paid."',
    empathyLine: 'Disputes logged against the right invoice clear in days. Against the wrong one? Weeks.',
  },
  'promise-to-pay': {
    term: 'promise-to-pay',
    title: 'promise-to-pay',
    definition:
      'A commitment from the customer: specific date, specific amount. The goal of every collections call.',
    empathyLine: 'Vague promises ("soon") aren\'t promises. The specificity is what makes it real.',
  },
  'write-off': {
    term: 'write-off',
    title: 'write-off',
    definition:
      "Giving up on collecting. The amount gets recognized as bad debt on this period's P&L.",
    empathyLine: 'Small write-offs add up. Every $800 you surrender is $800 the CFO sees.',
  },
  dso: {
    term: 'dso',
    title: 'DSO (days sales outstanding)',
    definition:
      'Average number of days it takes to collect a dollar after invoicing. The top-line AR metric.',
    empathyLine: 'DSO of 47 against a target of 35 means twelve days of cash locked in the aging report.',
  },
};
